<ng-container *ngIf="initialized | async">
    <router-outlet></router-outlet>
</ng-container>
